/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_DescriptionInputs */



/**
* | output |
* | --- |
* | "Every MCP server members of your organization have added. Each server is a space: who can use it is set in that space's access settings." |
*
* @param {Mcp_Servers_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_description = /** @type {((inputs?: Mcp_Servers_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle MCP-Server, die Mitglieder Ihrer Organisation hinzugefügt haben. Jeder Server ist ein Space: Wer ihn nutzen darf, legen Sie in den Zugriffseinstellungen dieses Spaces fest.")
	return /** @type {LocalizedString} */ ("Every MCP server members of your organization have added. Each server is a space: who can use it is set in that space's access settings.")
});